
<template>
  <div class="desc" ref="main">
    <div class="move-box" :class="needRun ? 'run' : ''">
      <span
        class="title"
        :style="
          runTimeSecondLenght
            ? `animation-duration:${runTimeSecondLenght}s`
            : ''
        "
        :class="titleAlignCenter ? 'center' : ''"
        >{{ title || "" }}<slot v-if="!title"></slot
      ></span>
      <span
        class="title"
        :style="
          runTimeSecondLenght
            ? `animation-duration:${runTimeSecondLenght}s`
            : ''
        "
        v-if="needRun"
        >{{ title || "" }}<slot v-if="!title"></slot
      ></span>
    </div>
    <span class="hidden title" ref="testTitle"
      >{{ title || "" }}<slot v-if="!title"></slot
    ></span>
  </div>
</template>

<script>
export default {
  props: {
    title: {},
    textAlign: {},
    runTimeSecondLenght: {},
    static: {},
    textData: {},
  },
  data() {
    return {
      needRun: false,
    };
  },
  watch: {
    static() {
      this.calcNeedRun();
    },
    title() {
      this.calcNeedRun();
    },
    textData() {
      this.$nextTick(() => {
        this.calcNeedRun();
      });
    },
  },
  computed: {
    titleAlignCenter() {
      return this.textAlign == "center" && !this.needRun;
    },
  },
  methods: {
    calcNeedRun() {
      if (this.static) {
        this.needRun = false;
        return;
      }
      if (this.$refs.testTitle) {
        if (this.$refs.testTitle.clientWidth > this.$refs.main.clientWidth) {
          this.needRun = true;
        } else {
          this.needRun = false;
        }
      }
    },
  },
  mounted() {
    this.calcNeedRun();
  },
};
</script>

<style lang="scss" scoped>
.desc {
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  .move-box {
    display: inline-block;
    .title {
      position: relative;
      padding-right: 0.3rem;

      &.center {
        padding: 0;
      }
    }
    &.run .title {
      animation: mymove1 10s infinite linear;
    }
  }
  .title {
  }
  .hidden {
    position: absolute;
    top: 110%;
    left: 0;
  }
}
@-webkit-keyframes mymove1 {
  0% {
    left: 0px;
  }
  100% {
    left: -50%;
  }
}
</style>
